export var FieldLabels = {
  cardholderName: 'Name on card',
  zip: 'Zip/Postal Code',
  number: 'Card number',
  expirationDate: 'Expiration date',
  expirationMonth: 'Expiration month',
  expirationYear: 'Expiration year',
  cvv: 'CVV'
};
export var Validations = {
  required: '{field} is required.',
  invalid: '{field} is invalid.',
  alphanumeric: '{field} is invalid.',
  onlyLettersAndCertainChars: "Only letters and special characters: `'~.- can be used.",
  numeric: 'Only numbers: 0-9 can be used.',
  required_upi: 'PIN code must be exactly 6 numbers.',
  numeric_upi: 'PIN code must be exactly 6 numbers.',
  length_upi: 'PIN code must be exactly 6 numbers.'
};
export var InterstitialProducts = /*#__PURE__*/function (InterstitialProducts) {
  InterstitialProducts["CS"] = "CS";
  InterstitialProducts["CSP"] = "CSP";
  return InterstitialProducts;
}({});
export var CSP_PRICE_ERROR_MESSAGE = 'Error with getPricingData - failed to get CSP pricing';
export var CS_PRICE_ERROR_MESSAGE = 'Error with getPricingData - failed to get CS pricing';
export var AUTHORIZE_ERROR_MESSAGE = 'Error with getPricing authorize call';
export var RAW_STUDY_SUB_ERROR_MESSAGE = 'Error with digitalOrderLineItems call - failed to get existing subscription details';
export var CW_TEAM_NAME = 'CW';

/**
 * Product IDs maintained on the following Confluence pages
 *
 * https://chegg.atlassian.net/wiki/spaces/ecom/pages/2615939/Recurring+Items+-+Fixed+Bundle
 * https://chegg.atlassian.net/wiki/spaces/ecom/pages/2615402/One+Time+Items
 * https://chegg.atlassian.net/wiki/spaces/CPT/pages/1154398560/SM3.0+Item+IDs
 **/
export var SALLIE_MAE_PRODUCT_IDS = new Set(['CHGCS2MnthNFTSM', 'CHGCS4MnthNFTSM', 'CHGCSPCS4MnthNFTSM3', 'CHGCSPCW4MnthNFTSM3', 'CHGCSPCM4MnthNFTSM3', 'CHGCSP4MnthNFTSM3', 'CHG2BCSCMMnthNFTSM3', 'CHG2BCSCW4MnthNFTSM3', 'CHG2BCWCM4MnthNFTSM3']);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/constants/Strings.js
// module id = 331
// module chunks = 11